import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/crm/crm.contactsByEmails.query.gql"
import type {
  ContactsByEmailsQuery,
  ContactsByEmailsQueryVariables,
} from "@/v2-backoffice-client/crm/__types__/crm.contactsByEmails.query"

type Options = QueryHookOptions<
  ContactsByEmailsQuery,
  ContactsByEmailsQueryVariables
>

export function useContactsByEmailsQuery(options?: Options) {
  return useQuery<ContactsByEmailsQuery, ContactsByEmailsQueryVariables>(
    query,
    options,
  )
}
